// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"e04bd0d8","164":"6aafb559","198":"1716ffb2","245":"3f9d30f6","899":"b40c1392"}[chunkId] + ".chunk.js";
};